<template>
  <div class="comex-bar comex-bar--skeleton" aria-busy="true" aria-label="Chargement">
    <div class="item item--skeleton" />
  </div>
</template>

<style scoped lang="scss">
@use "~/assets/scss/partials/orga/national-grid" as *;
@use "~/assets/scss/partials/elpdl/spacing" as *;

.comex-bar--skeleton {
  display: flex;
  justify-content: center;
}

.item--skeleton {
  width: min(16rem, 80%);
  min-height: 3rem;
  border-radius: $spacing-2xs;
  background: var(--color-bg-muted);
}
</style>
